"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Authentication_module_1 = require("./modules/Authentication.module");
const Product_module_1 = require("./modules/Product.module");
const loadProductReviewLandingModule = (initialData) => ({
    hasRouter: false,
    modules: [(0, Product_module_1.default)(initialData), (0, Authentication_module_1.default)()],
});
exports.default = loadProductReviewLandingModule;
